var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_check_mark_layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.75,28.7a1.5,1.5,0,0,0-2,.55L56.92,84.51,34.08,60.63a1.5,1.5,0,1,0-2.16,2.07L56.13,88a1.55,1.55,0,0,0,1.09.46h.18a1.51,1.51,0,0,0,1.12-.74l32.78-57A1.5,1.5,0,0,0,90.75,28.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckMark);
export default __webpack_public_path__ + "static/media/icon-check-mark.9fe895df.svg";
export { ForwardRef as ReactComponent };